import classNames from 'classnames'
import React from 'react'
import { useBrewDetailStore } from '../../state/useBrewDetailStore'

const IBU: React.FC = () => {
    const { ibu, productData } = useBrewDetailStore()
    const styleIbu =
        productData?.style?.ibuMin &&
        productData?.style?.ibuMax &&
        `${productData?.style?.ibuMin} - ${productData?.style?.ibuMax}`
    const anyIbu = ibu || styleIbu || '--'
    const textClasses = classNames('text-dark ', anyIbu !== '--' ? 'font-bold text-lg' : '')
    return (
        anyIbu && (
            <div className='flex flex-col gap-2'>
                <div className='flex items-center gap-1'>
                    <span className='text-base font-bold text-gray-300'>IBU</span>
                </div>
                <span className={textClasses}>{anyIbu}</span>
            </div>
        )
    )
}

export default IBU
